/** Memory, remotely: the graph's health and "ask the graph". */

import { dateShort } from '@aioe/shared/wording/dateTime';
import { FileText, GraphNode, NodesRight } from '@gravity-ui/icons';
import { useState } from 'react';

import { Button, inputClass, ListBlock, ListGroup, Stat } from '../../components/ui.tsx';
import type { MemoryStatus, Workbench } from '../useWorkbench.ts';
import { Markdown } from '../../components/Markdown.tsx';
import { RemoteView } from './RemoteView.tsx';

export function MemoryView({ w }: { w: Workbench }) {
  const status = w.useView<MemoryStatus>('memory.status', undefined, [], 60_000);
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState<string>();
  const [busy, setBusy] = useState(false);
  const s = status.data;
  async function ask() {
    if (!question.trim()) return;
    setBusy(true);
    await w.act('Ask', async () => setAnswer((await w.call<{ text: string }>('memory.query', { question: question.trim(), scope: 'all' }))?.text));
    setBusy(false);
  }
  return (
    <RemoteView narrow>
      <div className="art-stats">
        <Stat tone="violet" icon={<GraphNode />} label="Nodes" value={s?.nodes} detail={s?.engine ?? ''} />
        <Stat tone="blue" icon={<NodesRight />} label="Links" value={s?.links} detail={s?.communities !== undefined ? `${s.communities} communities` : ''} />
        <Stat tone="rose" icon={<FileText />} label="Stale files" value={s?.staleFiles} detail={s?.graphUpdatedAt ? `graph from ${dateShort(s.graphUpdatedAt)}` : ''} needsYou={(s?.staleFiles ?? 0) > 0} />
      </div>
      <ListGroup title="Ask the graph" description="The same question box the app has; the answer comes from the workbench's memory.">
        <ListBlock>
          <div className="flex gap-2">
            <input className={inputClass} aria-label="Question" value={question} onChange={(e) => setQuestion(e.target.value)} placeholder="How are sessions stored?" onKeyDown={(e) => e.key === 'Enter' && void ask()} disabled={!w.connected} />
            <Button size="sm" variant="primary" isPending={busy} isDisabled={!question.trim() || !w.connected} onPress={() => void ask()}>
              Ask
            </Button>
          </div>
        </ListBlock>
        {answer ? (
          <ListBlock>
            <Markdown breaks className="text-sm" text={answer} />
          </ListBlock>
        ) : null}
      </ListGroup>
    </RemoteView>
  );
}
